<h1 mat-dialog-title>{{ 'case.new_case_dialog_title' | translate }}</h1>

<div mat-dialog-content>
    
    <div class="row">
        <div class="col-sm-12">
            <mat-form-field class="full-width">
                <mat-label>{{ data.case.trans.office | translate }}</mat-label>
                <mat-select id="create_case_dialog.input_select.office"
                            [(ngModel)]="selectedOffice" required>
                    <mat-option *ngFor="let office of offices; let idx = index"
                                id="create_case_dialog.input_select.office.option_{{idx}}"
                                [value]="office">
                        {{ office.actionListDisplayName | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row" *ngIf="workflows.length">
        <div class="col-sm-12">
            <mat-form-field class="full-width">
                <mat-label>{{ data.case.trans.workflow | translate }} ({{ 'common.label.optional' | translate }})</mat-label>
                <mat-select id="create_case_dialog.input_select.workflow"
                            [(ngModel)]="selectedWorkflow">
                    <mat-option *ngFor="let workflow of workflows let idx = index"
                                id="create_case_dialog.input_select.workflow.option_{{idx}}"
                                [value]="workflow">
                        {{ workflow.actionListDisplayName | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6 no-gutters pl-0">
        <button mat-raised-button
                id="create_case_dialog.btn.ok"
                class="full-width" color="accent"
                (click)="accept()"
                [disabled]="!selectedOffice">
            {{ 'common.btn.ok' | translate }}
        </button>
    </div>

    <div class="col-sm-6 no-gutters pr-0">
        <button mat-stroked-button
                color="primary"
                id="create_case_dialog.btn.cancel"
                class="full-width"
                *ngIf="!data.removeCancelBtn"
                (click)="close()">
            {{ 'common.btn.cancel' | translate }}
        </button>
    </div>

</div>
